import {Agent, Query, request} from './base';

import {WebLocale} from 'models/web-locale';
import {LocaleStats} from 'models/locale-stats';
import {LocaleHistory} from 'models/locale-history';
import {WebLocaleKey} from 'models/web-locale-key';
import {WebLocaleContent} from 'models/web-locale-content';
import {WebLocaleCategory} from 'models/web-locale-category';

import {WebPage} from 'models/web-page';
import {WebPageSync} from 'models/web-page-sync';
import {WebPageLanguage} from 'models/web-page-language';
import {WebPageCategory} from 'models/web-page-category';

export class WebsiteAgent {
    localeKeys = new Agent(WebLocaleKey, '/website/locales/keys');
    localeContent = new Agent(WebLocaleContent, '/website/locales/content');
    localeCategories = new Agent(WebLocaleCategory, '/website/locales/categories');

    getLocales = async ({categoryId, motherLangId, targetLangId}: {
        categoryId: number;
        motherLangId: number;
        targetLangId: number;
    }) => {
        const res = await request.get('/website/locales', {categoryId, motherLangId, targetLangId}) as WebLocale[];
        return res.map(el => new WebLocale(el));
    };

    pages = new Agent(WebPage, '/website/pages');

    pageCategories = new Agent(WebPageCategory, '/website/pages/categories');

    pageLanguages = new Agent(WebPageLanguage, '/website/pages/languages');

    getSyncStatus = async (query?: Query) => {
        const res = await request.get('/website/pages/sync', query) as WebPageSync[];
        return res.map(el => new WebPageSync(el));
    };

    getLocaleStats = (languageId: number, categoryId?: number) => {
        let url = `/locales/stats/website/${languageId}`;

        if (categoryId) {
            url += '/' + categoryId;
        }

        return request.get(url) as Promise<LocaleStats>;
    };

    getLocaleHistory = async (contentId: number) => {
        const res = await request.get('/locales/history/website/' + contentId) as LocaleHistory[];
        return res.map(el => new LocaleHistory(el));
    };

    sync = async () => {
        return request.post('/website/pages/sync', {});
    };

    setOutdated = async (id: number) => {
        return request.patch(`/website/locales/content/outdated/${id}`, {});
    };

    setOutdatedAll = async (keyId: number, exceptionId: number) => {
        return request.patch(`/website/locales/content/outdated/${keyId}/${exceptionId}`, {});
    };
}
